import { FormikErrors, FormikTouched } from "formik";
import React from "react";

interface LabelInsideInputProps {
  label: string;
  id: string;
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
  error?:
    | string
    | string[]
    | FormikErrors<any>
    | FormikErrors<any>[]
    | undefined;
  width?: string;
  showLabel?: boolean;
  disabled?: boolean;
  placeholder?: string;
  type?: string;
}

const LabelInsideInput: React.FC<LabelInsideInputProps> = ({
  label,
  id,
  value,
  onChange,
  onBlur,
  error,
  width = "w-100",
  touched,
  showLabel = true,
  disabled = false,
  placeholder,
  type = "text",
}) => {
  return (
    <div className={"text-field-section" + " " + width}>
      {label !== null ? (
        <>
          <label htmlFor="">{label}</label>
        </>
      ) : null}
      <div
        className={`input-container-wrapper ${
          error ? "label-inside-input-error" : ""
        } ${disabled ? "label-inside-input-disabled" : ""}`}
      >
        {/* <div className="label-inside-input-label">{label}</div> */}
        <input
          type={type}
          id={id}
          placeholder={placeholder}
          name={id}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          className="input-control"
          disabled={disabled}
        />
        {touched && error && (
          <div className="error-line">
            <span>{error as string}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LabelInsideInput;
